<template>
    <div>            
        <!-- <NeedUpload v-if="state == 1" :step="route.query.step" :allstep="route.query.as" @changeState="changeState"></NeedUpload>         -->
        <NoNeedUpload v-if="state == 1" :step="route.query.step" :allstep="route.query.as"  @changeState="changeState"></NoNeedUpload>                       
        <Manual v-if="state == 3" :step="route.query.step" :allstep="route.query.as" @changeState="changeState"></Manual>
        <ManualOcr v-if="state == 2" :step="route.query.step" :allstep="route.query.as" @changeState="changeState"></ManualOcr>
        <!-- <div class="placeholder"></div>
        <div class="btn-container">            
            <a class='btn-submit' @click="submit">CONFIRM TO NEXT</a>
        </div> -->
    </div>
</template>
<style lang="less" scoped>
    .btn-container{
        position: fixed;
        left:0;
        bottom: 0;        
        background:#fff;
        padding:40px;
        // padding:40px;
        .btn-submit{
            display: block;
            width: 670px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            border-radius: 12px;
            background:#9C73E2;
            font-size: 32px;
            margin:0 auto;
            color:#fff;
        }
    }
    .placeholder{
        height: 176px;        
    }
    .hih-caption{
        color:#A59BB3;
        font-size:28px;
        margin-bottom: 30px;
        line-height: 1.5;
    }
    .wrapper{
        padding:40px;
        .guide{
            color:#A59BB3;
            font-size: 30px;
            em{
                color:#9C73E2;
                font-weight: 700;
            }
        }
        .title{
            color:#9C73E2;
            font-size: 40px;
            margin: 50px 0;  
        }
    }
</style>
<script>   
// import NeedUpload from '@/components/business/kyc/compose/needupload.vue'
import NoNeedUpload from '@/components/business/kyc/compose/noupload.vue'
import Manual from '@/components/business/kyc/compose/manual.vue'
import ManualOcr from '@/components/business/kyc/compose/manualOcr.vue'

import { onMounted, getCurrentInstance,ref } from 'vue'
import {  getKycinfo } from '@api/index'
import { useRouter } from 'vue-router'
export default {
    components:{
        // NeedUpload,
        NoNeedUpload,
        Manual,
        ManualOcr
    },
    setup() {                
        const proxy = getCurrentInstance().proxy        
        const state = ref("0") 
        const router = useRouter()
        const route = router.currentRoute
        const changeState = (v) => {
            state.value = v
        }          
        onMounted(async () => {            
            // document.body.style.background = '#F8F8F8'
            const data = await getKycinfo()  
            if(data.code == 0) {
                if (data.data['kycPageType'] == 1 ) {
                    state.value = 2
                } else if (data.data['kycPageType'] == 4 ) {
                    state.value = 3
                } else {
                    state.value = 1
                }
            } else {
                proxy.$toast.show(data.msg)
            }
            
        })
        return {
            state,
            route,
            changeState
        }
    }
}
</script>